import { Authority, Skyddsklassningsaktivitet } from 'models';

import { AuthorityRolesEnum, bmSkyddsklassningstyper, kkmSkyddsklassningstyper, sbmSkyddsklassningstyper } from 'enums';

import { isAnsvarigOrganisation } from 'utilities/bebyggelseobjektUtilities';

export const useIsAllowedToEditSkyddsklassning = (
  skyddsklassningsAktivitet: Skyddsklassningsaktivitet | undefined,
  selected_organisation: Authority | undefined,
  rolesInSelectedOrganisation: Array<AuthorityRolesEnum> | undefined
) => {
  if (!skyddsklassningsAktivitet || !selected_organisation || !rolesInSelectedOrganisation) return false;

  const isAnsvarigOrg = isAnsvarigOrganisation(skyddsklassningsAktivitet, selected_organisation);

  if (sbmSkyddsklassningstyper.includes(skyddsklassningsAktivitet.skyddsklassningstyp_id)) {
    return isAnsvarigOrg && rolesInSelectedOrganisation.includes(AuthorityRolesEnum.SBM_HANDLAGGARE);
  }

  if (
    [...kkmSkyddsklassningstyper, ...bmSkyddsklassningstyper].includes(skyddsklassningsAktivitet.skyddsklassningstyp_id)
  ) {
    return isAnsvarigOrg && rolesInSelectedOrganisation.includes(AuthorityRolesEnum.BM_HANDLAGGARE);
  }

  return false;
};
